<template>
  <div class="detail">
    <div class="goods-detail" v-if="goods.id">
      <div class="category">
        <a :href="'/products/'+category.id"><i class="el-icon-back"></i> {{category.category_name}}</a>
      </div>
      <el-row :gutter="50">
        <el-col :span="12" :offset="0">
          <div class="detail-left">
            <el-carousel height="500px" class="swiper" :autoplay="false" indicator-position="none">
              <el-carousel-item v-for="(item,index) in swiper" :key="index">
                <video controls height="500px" width="100%" loop muted :poster="config.imageDisplayBaseUrl + item.coverImage" v-if="item.type === 'video'">
                  <source :src="item.path" type="video/mp4">
                </video>
                <div class="swiper-image" :style="'background-image: url('+item.path+')'" v-else></div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :span="12" :offset="0">
          <div class="detail-right">
            <div class="goods-title">{{goods.name}}</div>
            <div class="goods-ename">{{goods.name_e}}</div>
            <div class="goods-price">￥{{goods.price}}</div>
            <el-collapse v-model="activeNames">
              <el-collapse-item title="了解详情" name="1">
                <div>{{goods.description}}</div>
              </el-collapse-item>
              <el-collapse-item title="成分" name="2">
                <div>{{goods.composition}}</div>
              </el-collapse-item>
              <el-collapse-item title="使用方法" name="3">
                <div>{{goods.usage}}</div>
              </el-collapse-item>
              <el-collapse-item title="规格" name="4">
                <div class="specification">{{goods.specification}}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-empty v-else description="未找到对应商品" ></el-empty>
  </div>
</template>

<script>
import { config } from '@/self/config.js'
export default {
  data () {
    return {
      config: config,
      goods: {},
      category: {},
      activeNames: ['1', '2', '3', '4'],
      swiper: []
    }
  },
  watch: {
    $route (to, from) {
      this.getGoodsInfoById(this.$route.params.id)
    }
  },
  methods: {
    getGoodsInfoById (id) {
      const that = this
      that.axios.get('goods/' + id).then(function (resp) {
        that.goods = resp.data.goods
        const swiper = []
        for (let i = 0; i < resp.data.goods.swiper.length; i++) {
          const item = resp.data.goods.swiper[i]
          item.path = config.imageDisplayBaseUrl + item.path
          swiper.push(item)
        }
        that.category = resp.data.category
        that.swiper = swiper
      })
    }
  },
  mounted () {
    this.getGoodsInfoById(this.$route.params.id)
  }
}
</script>

<style scoped>
.category{
  font-size: 12px;
  font-style: italic;
  margin-bottom: 20px;
}
.goods-detail{
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 50px;
}
.swiper{
  width: 100%;
}
.swiper-image{
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.detail-right{
  width: 100%;
  box-sizing: border-box;
}
.goods-title{
  font-size: 30px;
  font-weight: 300;
  font-style: italic;
  box-sizing: border-box;
  padding-bottom: 5px;
}
.goods-ename{
  font-size: 12px;
  font-weight: 300;
  color: #a3a3a3;
  padding-bottom: 20px;
}
.goods-price{
  font-size: 23px;
  color: #25282a;
  font-weight: 600;
  margin-bottom: 20px;
}
.specification{
  display: inline-block;
  border: 0.5px solid #25282a;
  padding: 3px 10px;
}
</style>
